/* eslint-disable @typescript-eslint/naming-convention */
import { useOutletContext, useParams } from "react-router-dom"
import { useSignal } from "@preact/signals-react"

import Button from "react-bootstrap/Button"
import Modal from 'react-bootstrap/Modal'
import Table from 'react-bootstrap/Table'

import SetMembershipCheckbox from "../../../../components/SetMembershipCheckbox.jsx"
import LoadingAnimation from '../../../../components/LoadingAnimation.jsx'

import { addGroupUsers } from "../../../../state/actions/groupActions.js"

import { groupUserListLoadedSignal, groupUserListErrorSignal, groupUserDictionarySignal } from '../../../../state/signals/groupSignals.js'
import { userListLoadedSignal, userListErrorSignal } from '../../../../state/signals/userSignals.js'

import { getUserStatusText } from '../../../../utils/utils'

const AddGroupUsersModal = ({ showSignal, userListSignal }) => {

	const { beId, groupId } = useParams()
	const { user, config, accessToken, userPermissions, userPermissionsSummary, accordionData } = useOutletContext()

	const enableSubmitSignal = useSignal(false)
	const selectedUsersSignal = useSignal(new Set())

	const closeModal = () => {
		showSignal.value = false
		enableSubmitSignal.value = false
		selectedUsersSignal.value = new Set()
	}

	const TableRows = () => {
		const f = "AddGroupUsersModal.TableRows()"
		if (!userListLoadedSignal.value || !groupUserListLoadedSignal.value) {
			return <tr><td colSpan={4}><LoadingAnimation /></td></tr>
		}
		if (!userListSignal.value) {
			<tr><td colSpan={4}>Error: User list signal has no value</td></tr>
		}
		const users = userListSignal.value
		if(users.length && users.length < 1){
			return (<tr><td colSpan={4} className='empty-record'>There are no users that can be added.</td></tr>)
		}
		let rows = []
		const set = new Set()
		for(let i = 0; i < users.length; i++){
			const user = users[i]
			if (user.id in groupUserDictionarySignal.value) {
				console.log(`${f}: User with ID ${user.id} is already a member of this group`)
				continue
			}
			rows.push(
				<tr key={user.id}>
					<td className="breakWordWrap">{user.firstName}</td>
					<td className="breakWordWrap">{user.lastName}</td>
					<td>{getUserStatusText(user)}</td>
					<td className='checkbox-container'>
						<SetMembershipCheckbox
							id={user.id}
							checkboxId={`AddGroupUserCheck:${user.id}`}
							selectedEntitySetSignal={selectedUsersSignal}
							enableSubmitSignal={enableSubmitSignal}
						/>
					</td>
				</tr>
			)
		}
		return rows
	}

	const addUsers = () => {
		let userKeys = Array.from(selectedUsersSignal.value)
		if (userKeys.length < 1) {
			window.alert("No users selected")
			return
		}
		addGroupUsers(groupId, userKeys, config, accessToken)
		closeModal()
	}

	//console.log("On render, the following users are selected:")
	//console.log(Array.from(selectedUsersSignal.value))

	return (
		<Modal size="lg" id='addUsers' show={showSignal.value} onHide={closeModal} className="unflex">
			<Modal.Header closeButton>
				<Modal.Title>Add Users</Modal.Title>
			</Modal.Header>
			<Modal.Body style={{display:"block", flex:"unset"}}>
				<Table className="table table-striped table-hover">
					<thead>
						<tr>
							<th>First Name</th>
							<th>Last Name</th>
							<th>User Status</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<TableRows />
					</tbody>
				</Table>
			</Modal.Body>
			<Modal.Footer>
				<Button className="btn btn-default" onClick={closeModal}>Cancel</Button>
				<Button className="btn btn-primary" onClick={addUsers} disabled={!enableSubmitSignal.value}>Add</Button>
			</Modal.Footer>
		</Modal>
	)
}
export default AddGroupUsersModal